import { Modal } from 'antd';
import { ConfirmationModalProps, ConfirmationModalType } from './types';

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  content,
  okText = 'OK',
  cancelText = 'Cancel',
  type = ConfirmationModalType.PRIMARY,
}: ConfirmationModalProps) {
  return (
    <Modal
      title={<div className="text-2xl font-medium">{title}</div>}
      open={isOpen}
      onCancel={onClose}
      onOk={onConfirm}
      okButtonProps={{
        color: type,
        variant: 'solid',
        size: 'large',
      }}
      cancelButtonProps={{
        variant: 'outlined',
        color: 'primary',
        size: 'large',
      }}
      okText={okText}
      cancelText={cancelText}
      classNames={{
        header: 'text-lg font-bold',
      }}
    >
      <div className="w-full border-y py-3 text-[#5E6B7C]">{content}</div>
    </Modal>
  );
}
